import { mapDTO } from '@twistezo/ts-dto-mapper'
import _ from 'lodash'
import { PartialDeep } from 'type-fest'

import {
  Variants,
  VariantsSchema,
} from 'features/ab-tests/forms/AbTestsCommonForm/abTestsCommonSchema'
import { AbTestVariantAttributesDTO } from '../../useCreateAbTest/api/types'
import { mapVariant } from './variantsMapper'

import type { AbTestSlice } from '../types'
import type { AbTestSliceDTO } from './types'

type From = AbTestSliceDTO
type Props = From & {
  withYp2395: boolean
}

type To = AbTestSlice

export const fromDTO = ({ withYp2395, ...from }: Props): To =>
  mapDTO<From, To>({ from }).transform((data: From): To => {
    const { domain, id, name, status, usedVariantsData, variants } = data

    if (_.isEmpty(variants) || !('variants' in variants) || _.isEmpty(variants.variants)) {
      throw Error('Variants should be available')
    }

    const parsedVariants = Object.fromEntries(
      Object.entries(variants.variants).map(
        ([key, value]: [key: string, value: PartialDeep<AbTestVariantAttributesDTO>]): [
          string,
          VariantsSchema,
        ] => [key, mapVariant(value)],
      ),
    ) as Variants

    return {
      cookieLifetime: withYp2395 ? from.cookieLifetime : undefined,
      domain: {
        activeAbTest: domain.activeAbTest
          ? {
              id: domain.activeAbTest.id,
            }
          : undefined,
        id: domain.id,
        name: domain.name,
      },
      id,
      name,
      status,
      trafficSplitType: withYp2395 ? from.trafficSplitType : undefined,
      usedVariantsData: usedVariantsData ?? [],
      variants: parsedVariants,
    }
  })
